module.exports = __webpack_public_path__ + "static/media/CB.301f35ce.png";